import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FileUploadComponent} from 'shared/lib/file-upload/file-upload.component';
import {FilePondModule} from 'ngx-filepond';
import {IconSpritesModule} from 'shared/lib/icon-sprite/icon-sprite.component';


@NgModule({
	declarations: [
		FileUploadComponent
	],
	exports: [
		FileUploadComponent
	],
	imports: [
		CommonModule,
		FilePondModule,
		IconSpritesModule
	]
})
export class FileUploadModule {}
